import { Inbox } from 'lucide-react'
import { StatCard } from '@/components/StatCard'
import type { InboxCategoryCount } from '@/features/inbox/types'
import { categoryAccent, categoryIcon } from '../categoryStyle'

interface CategoryCardsRowProps {
  counts: InboxCategoryCount[]
  total: number
  loading: boolean
  activeCategoryId: string | null
  onSelect: (categoryId: string | null) => void
}

export function CategoryCardsRow({
  counts,
  total,
  loading,
  activeCategoryId,
  onSelect,
}: CategoryCardsRowProps) {
  if (loading) {
    return (
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6">
        {Array.from({ length: 6 }).map((_, i) => (
          <StatCard key={i} label="Loading" value="-" hint="Loading" />
        ))}
      </div>
    )
  }

  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6">
      <StatCard
        label="All mail"
        value={total}
        icon={Inbox}
        tone="hero"
        onClick={() => onSelect(null)}
        selected={activeCategoryId === null}
      />
      {counts.map((c) => {
        const token = c.is_system ? c.slug : c.category_id
        return (
          <StatCard
            key={c.category_id}
            label={c.name}
            value={c.count}
            icon={categoryIcon(c.icon)}
            className={c.is_system ? undefined : categoryAccent(c.color)}
            onClick={() => onSelect(token)}
            selected={activeCategoryId === token}
          />
        )
      })}
    </div>
  )
}
